'use client';

import React from 'react';
import ContentCalendar from '@/components/calendar/ContentCalendar';
import { Box } from '@mui/material';

export default function CalendarPage() {
  return (
    <Box
      className="calendar-page"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        minWidth: 0,
        maxWidth: '100vw',
        p: { xs: 0, sm: 2 },
        px: { sm: 3 },
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <ContentCalendar />
      </Box>
    </Box>
  );
}

